import {BaseLinkParams} from "../../../infrastructure/models/link/base-link-params";

export class CompetitionLinkParams extends BaseLinkParams  {
  id: Number;
  competitionName: String;
  sportName: String;
  key: String;

  constructor(id: Number, sportName: String, competitionName: String, page: String) {
    super();

    this.id = id;
    this.sportName = sportName;
    this.competitionName = competitionName;
    this.key = `${competitionName}-${id}`;
    this.page = page;
  }
}
